"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NOTIFICATION_TRIGGER;
(function (NOTIFICATION_TRIGGER) {
    NOTIFICATION_TRIGGER["NEW_ONE_TIME_JOBS"] = "newOneTimeJobs";
    NOTIFICATION_TRIGGER["NEW_LONG_TERM_JOBS"] = "newLongTermJobs";
    NOTIFICATION_TRIGGER["NEW_FULL_TIME_JOBS"] = "newFullTimeJobs";
})(NOTIFICATION_TRIGGER = exports.NOTIFICATION_TRIGGER || (exports.NOTIFICATION_TRIGGER = {}));
var NOTIFICATION_CHANNEL;
(function (NOTIFICATION_CHANNEL) {
    NOTIFICATION_CHANNEL["PHONE"] = "phone";
    NOTIFICATION_CHANNEL["WEB"] = "web";
    NOTIFICATION_CHANNEL["EMAIL"] = "email";
})(NOTIFICATION_CHANNEL = exports.NOTIFICATION_CHANNEL || (exports.NOTIFICATION_CHANNEL = {}));
//# sourceMappingURL=users.js.map